import vrboConnectUser from './vrboConnectUser';
import vrboDisconnectUser from './vrboDisconnectUser';
import vrboUpdateDefaultLodgingConfig from './vrboUpdateDefaultLodgingConfig';
import vrboConnectRental from './vrboConnectRental';
import vrboDisconnectRental from './vrboDisconnectRental';
import vrboUpdateRentalConfig from './vrboUpdateRentalConfig';

export default {
  vrboConnectUser,
  vrboDisconnectUser,
  vrboUpdateDefaultLodgingConfig,
  vrboConnectRental,
  vrboDisconnectRental,
  vrboUpdateRentalConfig,
};



// WEBPACK FOOTER //
// ./src/app/services/vrbo/index.js